export default "__VITE_ASSET__HuU6xAGs__"